<template>
  <div id="admin-work-license-manage-list">
    <!-- 上岗证管理列表 -->
    <diy_table
      :loading="loading"
      :buttonList="buttonList"
      :searchData="searchData"
      :tableMenu="tableMenu"
      :tableData="tableData"
      :tableButton="tableButton"
      :pageData="pageData"
      :tableState="true"
      @handleClickTop="handleClickTop"
      @initTable="initTable"
      @handleClick="handleClick"
    ></diy_table>

    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.dialogData"
      :buttonList="dialogData.buttonList"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
    ></diy_dialog>
  </div>
</template>

<script>
import * as workLicenseData from "./js/work_license.js";
import * as base from "../js/base.js";
export default {
  data() {
    return {
      loading: false,
      buttonList: this.$systemBaseData.getTopButArray(
        "workLicenseManageUserList"
      ),
      searchData: workLicenseData.getSearchData("workLicenseManageUserList"),
      tableMenu: this.$systemBaseData.getTableMenuData(
        "workLicenseManageUserList"
      ),
      tableData: [],
      tableButton: this.$systemBaseData.getTableButtonList(
        "workLicenseManageUserList",
        ""
      ),
      pageData: {
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 0, // 总条目数
      },

      tempTask: {}, // 临时任务
      options: {
        professionalId: [],
        uId: [],
        stationId: [],
      },

      dialogData: {
        flag: false,
        title: "上岗证预览",
        width: "40%",
        tempData: {},
        dialogData: [],
        buttonList: [
          { text: "确定", active: "makesure_choose_import_type" },
          { text: "取消", active: "cancel" },
        ],
      },

      allAuthorityList: [],
    };
  },
  methods: {
    // 权限设置  获取部门设置界面所有子界面的权限  考试管理 33
    async getUsersAllAuthorityByModel() {
      try {
        let resultData = await this.$request({
          url: "/authority/getUsersAllAuthorityByModel",
          method: "post",
          data: { feature: "33" },
        });
        this.buttonList = base.returnAllButton(
          this.buttonList,
          resultData,
          "name"
        );
        this.allAuthorityList = resultData;
      } catch (error) {}
    },
    /**
     * 获取所有学员下拉框数据
     */
    async getUserDropList() {
      try {
        let resultData = await this.$request({
          url: "/user/getUserDropList",
          method: "post",
          data: null,
        });
        this.options.uId = [];
        resultData.forEach((element) => {
          let dd = {
            label: element.name,
            value: element.id,
          };
          this.options.uId.push(dd);
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 获取专业下拉框数据
     */
    async getProfessionalList() {
      try {
        let resultData = await this.$request({
          url: "/professional/getProfessionalList",
          method: "post",
          data: { name: "" },
        });
        this.options.professionalId = [];
        resultData.forEach((element) => {
          let dd = {
            label: element.name,
            value: element.id,
          };
          this.options.professionalId.push(dd);
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 获取工种/岗位下拉框数据
     */
    async getListByType() {
      try {
        let resultData = await this.$request({
          url: "/dictionaries/getListByType",
          method: "post",
          data: { type: "station" },
        });
        this.options.station = [];
        resultData.forEach((element) => {
          let dd = {
            label: element.mean,
            value: element.id,
          };
          this.options.station.push(dd);
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 获取界面数据获取已归档的考核任务
     */
    async initTable(data) {
      try {
        this.loading = true;
        let requestData = {
          status: "2",
          currentPage: data.pageData.currentPage,
          pageSize: data.pageData.pageSize,
        };
        requestData = this.$baseData.array2json(data.searchData, requestData);
        let resultData = await this.$request({
          url: "/workLicense/getAllWorkLicenseUserList",
          method: "post",
          data: requestData,
        });
        setTimeout(() => {
          this.tableData = resultData.tableData;
          this.tableData.forEach((element) => {
            if (element.status == "作废") {
              this.$set(element, "rowColor", "#ff3737");
            } else {
              this.$set(element, "rowColor", "#22c02f");
            }
            let buttList = this.$systemBaseData.getTableButtonList(
              "workLicenseManageUserList",
              element.status
            );
            buttList = base.returnAllButton(
              buttList,
              this.allAuthorityList,
              "text"
            );
            this.$set(element, "butList", buttList);
          });
          this.pageData.total = resultData.total;
          this.loading = false;
        }, 300);
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    /**
     * 搜索框边的按钮操作
     */
    async handleClickTop(active) {
      try {
        switch (active) {
          case "import":
            // 导入上岗证
            this.dialogData.dialogData = [
              {
                type: "import",
                value: {
                  type: "10",
                  way: "0",
                  fileUrl: "", // 已上传的模板路径
                  fileName: "", // 已上传的模板名称
                  wayOptions: [{ label: "EXCEL 导入", value: "0" }],
                },
              },
            ];
            this.dialogData.title = "上岗证导入";
            this.dialogData.buttonList = [
              { text: "确定", active: "makesure_import" },
              { text: "取消", active: "cancel" },
            ];
            this.dialogData.flag = true;
            break;
          case "export":
            // 导入上岗证
            let requestData = {
              status: "2",
            };
            requestData = this.$baseData.array2json(
              this.searchData,
              requestData
            );
            this.$requestForReport(
              "post",
              "/workLicense/exportWorkUser",
              requestData,
              (data) => {
                let blob = new Blob([data], {
                  type: "application/force-download",
                }); // Blob 对象表示一个不可变、原始数据的类文件对象
                console.log(blob);
                let fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
                fileReader.readAsDataURL(blob);
                //开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
                fileReader.onload = (e) => {
                  let a = document.createElement("a");
                  a.download = `人员上岗证信息表.xls`;
                  a.href = e.target.result;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                };

                this.$message({
                  type: "success",
                  message: "导出成功!",
                  duration: 1000,
                });
              }
            );
            break;

          default:
            break;
        }
      } catch (error) {}
    },
    /**
     * 表格中的操作事件
     */
    async handleClick(data) {
      try {
        console.log(data);
        let resultData = {};
        this.tempTask = JSON.parse(JSON.stringify(data.item));
        switch (data.active) {
          case "show":
            // 查看具体学员的上岗证信息
            this.dialogData.title = "上岗证预览";
            this.dialogData.width = "550px";
            this.dialogData.dialogData = [
              { type: "work_license", value: this.tempTask.id },
            ];
            this.dialogData.buttonList = [{ text: "关闭", active: "cancel" }];
            this.dialogData.flag = true;
            break;
          case "deduct":
            // 扣分
            resultData = await this.$request({
              url: "/workDeduction/getDeductForSelect",
              method: "post",
              data: { name: "" },
            });
            let options = [];
            resultData.forEach((element) => {
              let dd = {
                label: element.name,
                value: element.id,
              };
              options.push(dd);
            });
            this.dialogData.title = "上岗证扣分";
            this.dialogData.width = "40%";
            this.dialogData.dialogData = [
              {
                title: "扣分原因",
                value: "",
                type: "select-search",
                options: options,
                key: "workLicenseConfigId",
                placeholder: "请选择扣分原因",
              },
            ];
            this.dialogData.buttonList = [
              { text: "确定", active: "make_sure_deduction" },
              { text: "取消", active: "cancel" },
            ];
            this.dialogData.flag = true;
            break;
          case "record":
            // 查看扣分记录
            resultData = await this.$request({
              url: "/workLicense/showUserWorkLicenseDeductRecord",
              method: "post",
              data: { workId: this.tempTask.id },
            });
            this.dialogData.title = "上岗证扣分";
            this.dialogData.width = "40%";
            this.dialogData.dialogData = [
              {
                value: resultData,
                type: "deduct_record",
              },
            ];
            this.dialogData.buttonList = [{ text: "关闭", active: "cancel" }];
            this.dialogData.flag = true;
            break;
          case "edit":
            // 编辑上岗证
            this.dialogData.title = "上岗证编辑";
            this.dialogData.width = "40%";
            this.dialogData.dialogData = [
              {
                value: this.tempTask.number,
                type: "input",
                key: "number",
                title: "编号",
                isNotNull: true,
              },
              {
                value: this.tempTask.time,
                type: "time_date",
                key: "certificateTime",
                title: "发证日期",
                isNotNull: true,
              },
              {
                value: this.tempTask.becomeTime,
                type: "time_date",
                key: "becomeTime",
                title: "到期日期",
                isNotNull: true,
              },
            ];
            this.dialogData.buttonList = [
              { text: "确定", active: "make_sure_edit" },
              { text: "关闭", active: "cancel" },
            ];
            this.dialogData.flag = true;
            break;
          case "cancel":
            // 手动作废上岗证
            this.$confirm("此操作将永久作废当前上岗证, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(async () => {
                try {
                  resultData = await this.$request({
                    url: "/workLicense/cancelWorkUser",
                    method: "post",
                    data: { id: this.tempTask.id },
                  });
                  this.initTable({
                    pageData: this.pageData,
                    searchData: this.searchData,
                  });
                  this.$message({
                    type: "success",
                    message: "操作成功!",
                  });
                } catch (error) {
                  this.$message.error(error.message);
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
            break;
          case "delete":
            // 删除上岗证
            this.$confirm(
              "仅可对导入的上岗证进行删除操作,且删除的上岗证将同步清除所有相关数据, 是否继续?",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(async () => {
                try {
                  resultData = await this.$request({
                    url: "/workLicense/delWorkUser",
                    method: "post",
                    data: { id: this.tempTask.id },
                  });
                  this.initTable({
                    pageData: this.pageData,
                    searchData: this.searchData,
                  });
                  this.$message({
                    type: "success",
                    message: "操作成功!",
                  });
                } catch (error) {
                  this.$message.error(error.message);
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
            break;

          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 弹出框按钮操作
     */
    async dialogOper(active) {
      try {
        let requestData = {};
        let resultData = {};
        switch (active) {
          case "make_sure_deduction":
            // 确认扣分
            requestData = {
              id: this.tempTask.id,
            };
            requestData = this.$baseData.array2json(
              this.dialogData.dialogData,
              requestData
            );
            if (requestData.workLicenseConfigId == "") {
              throw { message: "请先选择扣分原因!" };
            }
            resultData = await this.$request({
              url: "/workLicense/deductWorkLicenseByUserId",
              method: "post",
              data: requestData,
            });
            this.$message.success("扣分成功!");
            this.dialogData.flag = false;
            await this.initTable({
              pageData: this.pageData,
              searchData: this.searchData,
            });
            break;
          case "make_sure_edit":
            // 确认编辑上岗证
            requestData = {
              id: this.tempTask.id,
            };
            this.dialogData.dialogData.forEach((element) => {
              if (element.isNotNull && element.value == "") {
                throw { message: element.title + " 不可为空!" };
              }
            });
            requestData = this.$baseData.array2json(
              this.dialogData.dialogData,
              requestData
            );
            resultData = await this.$request({
              url: "/workLicense/editWorkUser",
              method: "post",
              data: requestData,
            });
            this.$message.success("操作成功!");
            this.dialogData.flag = false;
            await this.initTable({
              pageData: this.pageData,
              searchData: this.searchData,
            });
            break;
          case "makesure_import":
            requestData = {
              filePath: this.dialogData.dialogData[0].value.fileUrl,
            };
            resultData = await this.$request({
              url: "/workLicense/importWorkUser",
              method: "post",
              data: requestData,
            });
            if (resultData.flag) {
              this.$message.success("导入成功!");
            } else {
              this.$notify({
                title: "提示",
                dangerouslyUseHTMLString: true,
                message: resultData.errData,
                duration: 0,
                type: "error",
              });
            }
            this.dialogData.flag = false;
            await this.initTable({
              pageData: this.pageData,
              searchData: this.searchData,
            });
            break;
          case "cancel":
            // 弹出框关闭
            this.colseDialog();
            break;

          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 弹出框关闭操作
     */
    colseDialog() {
      this.dialogData.flag = false;
    },
  },
  async mounted() {
    await this.getUsersAllAuthorityByModel();
    await this.getUserDropList();
    await this.getProfessionalList();
    await this.getListByType();
    this.searchData.forEach((element) => {
      if (element.type == "select") {
        element.options = this.options[element.key];
      }
    });
    await this.initTable({
      pageData: this.pageData,
      searchData: this.searchData,
    });
  },
};
</script>

<style lang="less" scoped>
#admin-work-license-manage-list {
  width: 100%;
  height: 100%;
  /deep/.el-select {
    width: 100%;
  }
}
</style>